import * as React from "react"
import { cn } from "~/lib/utils"
import { LucideIcon } from "lucide-react"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: LucideIcon
  iconPosition?: "left" | "right"
  iconClassName?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type,
      icon: Icon,
      iconPosition = "left",
      iconClassName,
      ...props
    },
    ref,
  ) => {
    return (
      <div className="relative">
        {Icon && iconPosition === "left" && (
          <div
            className={cn(
              "absolute left-3 top-1/2 -translate-y-1/2",
              iconClassName,
            )}
          >
            <Icon className="h-4 w-4" />
          </div>
        )}
        <input
          type={type}
          className={cn(
            "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
            Icon && iconPosition === "left" && "pl-9",
            Icon && iconPosition === "right" && "pr-9",
            className,
          )}
          ref={ref}
          {...props}
        />
        {Icon && iconPosition === "right" && (
          <div
            className={cn(
              "absolute right-3 top-1/2 -translate-y-1/2",
              iconClassName,
            )}
          >
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
    )
  },
)
Input.displayName = "Input"

export { Input }
